// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.devcfg {
    height: 100%;
    width: 100%;
}

.devcfg:not(.empty) {
    /* The workspace is the black gutter between the two panel surfaces. */
    background-color: var(--panel-bg-level-0);
    padding-left: 20px;
    padding-right: 20px;
    overflow-x: auto;
    overflow-y: auto;
}

.devcfg.empty {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.devcfg.empty .empty {
    padding: 50px;
    color: var(--black-45);
    font-style: italic;
}

.devcfg > .header {
    position: relative;
    display: flex;
    text-align: left;
    align-items: center;
}

.devcfg > .header > .title {
    padding: 15px;
    padding-left: 8px;
    width: 300px;

    font-size: 18px;
    color: var(--black-80);
    font-weight: bold;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 70%, transparent 100%);
}

.devcfg > .header > .popup-trigger {
    position: absolute;
    font-size: 24px;
    left: 300px;
}

.devcfg .dev-panel {
    background-color: var(--black-02);
    border-radius: 6px;
    height: 100%;
    width: 400px;
    padding: 20px;
}

.devcfg .field {
    margin-top: 4px;
    margin-bottom: 4px;
}

.devcfg .field:nth-child(1) {
    margin-top: 0px;
}

.devcfg .field:nth-last-child() {
    margin-bottom: 0px;
}

.devcfg .field > .name {
    color: var(--black-65);
    font-size: 15px;
    padding: 6px;
}

.devcfg .field.name .naming {
    display: flex;
    justify-content: left;
    position: relative;
}

.devcfg .field.name .naming .name {
    position: relative;
    width: 260px;
    white-space: nowrap;
    overflow: hidden;
}

.devcfg .field.name .naming .name::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    content: '';
    background: linear-gradient(to right, transparent, var(--black-10));
    pointer-events: none;
}

.devcfg .field.name .naming .name.edit {
    mask: none;
}

.devcfg .field.name .naming .name.edit::after {
    background: none;
}

.devcfg .field .notes {
    padding-right: 5px;
    padding-bottom: 3px;
    color: var(--black-65);
}

.devcfg .field .editable.notes,
.devcfg .field .editable.notes.edit {
    white-space: pre-wrap;
    overflow-y: auto;
    min-height: 100px;
    max-height: 380px;
}

.devcfg .field.name .naming > .reset {
    width: 24px;
    padding-left: 5px;

    text-align: center;
    align-items: center;
    display: flex;

    font-size: 24px;

    cursor: pointer;
    user-select: none; 
}

.devcfg .field.name .naming > .reset.disabled {
    color: var(--black-35);
}

/* A bare glyph, so it lifts relative to its own colour instead of taking a
   surface veil. It keeps its pointer cursor when disabled, hence the :not(). */
.devcfg .field.name .naming > .reset:not(.disabled):hover {
    filter: brightness(var(--hover-lift));
}

.devcfg .field .editable {
    min-height: 28px;

    border-radius: 6px;
    padding: 6px;
    padding-right: 0px;
    border: 1px solid var(--black-02);

    font-size: 13px;

    background-color: var(--black-10);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.devcfg .field .editable.edit {
    border-color: var(--black-35);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
}

.devcfg .field .editable :is(.edit, .view) {
    min-width: 10px;
}

.devcfg .panels {
    display: flex;
    gap: 20px;
    height: 100%;
}

.devcfg .panels > .device {
    background-color: var(--black-05);
    width: 316px;
    padding-right: 20px;
    border-radius: 8px;
    padding: 12px;
    flex-shrink: 0;
}

/* Config owns its existing content inset; the parent owns the separate black
   20px gutter between the two panel surfaces. */
.devcfg .panels > .modules {
    background-color: var(--black-02);
    flex-grow: 1;
    flex-shrink: 0;
    padding-left: 20px;
    /* Matches the config panel's inset so the sort control starts on the same
       line as its first field (Gosta, Aug 4) */
    padding-top: 12px;
    padding-bottom: 60px;
    max-width: 1000px;
    min-width: 800px;
}

.devcfg .panels > .modules > .node-sort {
    width: 75px;
    height: 22px;
    border-radius: 4px;

    font-size: 13px;
    font-weight: bold;

    padding-left: 12px;
    padding-right: 10px;
    margin-bottom: 8px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none;

    color: var(--black-05);
    background-color: var(--black-80);
}

.devcfg .panels > .modules > .node-sort:hover {
    background-color: var(--black-65);
}

.devcfg .panels > .modules > .module {
    background-color: var(--black-05);
    padding: 20px;
    padding-top: 10px;
    border-radius: 6px;
    margin-bottom: 6px;
}

/* Node cards are reordered by dragging, so they react to the pointer. The
   port-assign subpanel keeps its own darker fill: the card lifts, the box the
   node sits in doesn't. Menus portal out of the card and can cover their own
   trigger, so hold the hover while one is open. */
.devcfg .panels > .modules > .module:hover,
.devcfg .panels > .modules > .module:has([data-menu-open]) {
    background-image: linear-gradient(var(--hover-veil-soft), var(--hover-veil-soft));
}

.devcfg .panels > .modules > .module.selected {
    border-color: var(--black-45);
}

.devcfg .node-new {
    width: fit-content;
    background-color: green;
    margin-top: 20px;
}

.devcfg .node-new .add {
    font-size: 18px;
}

.devcfg .modules .port-assign .shape {
    text-align: left;
    display: flex;
    justify-content:space-between;
    align-items: center;
    flex-direction: column;
}

.devcfg .panels > .modules .shape .ports {
    height: 24px;
    width: 220px;
    text-align: center;
    display: flex;
    justify-content:center;
    align-items: center;
}

.devcfg .panels > .modules .shape .ports .port-choice {
    text-align: center;
    display: flex;
    justify-content:center;
    align-items: center;
    width: 50%;
    flex-direction: column;
}

.portlabel .disabled {
    color: var(--black-45);
}

.port-choose {
    background-color: red;
}

.portlabel {
    display: flex;
    justify-content:space-between;
    align-items: center;
}

.portlabel .port {
    color: var(--black-80);
}

.portlabel .mod {
    padding-left: 5px;
    color: var(--black-45);
}

.portlabel .submenu-list {
    transform: translate(30px, -3px);
}

.devcfg .panels .modules .shape .ports.high {
    position: relative;
}

.devcfg .panels .modules .shape .ports.low {
    position: relative;
}

.devcfg .panels .modules .shape .ports .port-choice .port {
    background-color: var(--black-00);
    border: 1px solid var(--black-35);
    color: var(--black-65);
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
    padding: 1px 4px 1px 4px;
    min-width: 60px;
}

.devcfg .panels .modules .shape .ports.low .port-choice .port {
    background-color: var(--black-45);
    color: var(--black-00);
}

/* Clicking a port chip opens its assignment menu. The low chips are already
   light, so the veil reads weakest there of anywhere in the app. */
.devcfg .panels .modules .shape .ports .port-choice .port:hover {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

.devcfg .panels .modules .shape .ports .arrow {
    font-size: 30px;
    height: 22px;

    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content:center;
}

.devcfg .panels .modules .shape .ports .arrow.to {
    position: relative;
    top: -3px;
}

.devcfg .panels .modules .shape .ports .arrow.from {
    position: relative;
    bottom: -4px;
}

.devcfg .modules .shape .chain-module .channel  {
    right: 8px;
}

.devcfg .modules .shape .chain-module .channel.L  {
    right: 36px;
}

.devcfg .panels .modules .grab {
    position: relative;
    top: -3px;
    right: -2px;
}

.devcfg .dir {
    background-color: red;
}

.devcfg .panels .modules .body {
    display: flex;
    justify-content:left;
    width: 100%;
    position: relative;
    padding-top: 10px;
}

.devcfg .modules .body .header {
    font-weight: 600;
    padding-bottom: 10px;
}

.devcfg .modules .status {
    width: 255px;
}

.devcfg .modules .status .completion {
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 13px;
    color: var(--green-1);
}

.devcfg .modules .status .completion.incomplete {
    color: var(--red-3);
}

/* The info mark is a real element, not a ::after, so the tooltip has something
   to hover on that isn't the whole status line */
.devcfg .modules .status .completion .info {
    font-size: 17px;
    font-weight: bold;
    cursor: default;
}

.devcfg .modules .subpanel .port-status {
    margin-top: 16px;
}

.devcfg .modules .module .header {
    width: 310px;
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: space-between;
}

.devcfg .modules .module .header .name {
    background-color: var(--black-10);
}

.devcfg .module .header .editable .name {
    position: relative;
    padding: 5px;
    padding-left: 8px;
    padding-right: 8px;

    color: var(--black-80);
    font-weight: 500;

    width: 280px;

    font-size: 14px;
    border-radius: 3px;
    border: 1px solid transparent;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.devcfg .module .header .editable .edit.name {
    border: 1px solid var(--black-35);
    mask: none;
}

.devcfg .modules .module .header .popup-trigger {
    font-size: 22px;
}

.devcfg .modules .subpanel.port-assign {
    background-color: var(--black-02);

    height: 134px;

    display: flex;
    align-items: center;
    text-align: center;
}

.devcfg .modules .subpanel {
    padding: 10px;
}

.devcfg .modes {
    color: var(--black-65);

    display: flex;
    justify-content:left;

    cursor: pointer;
    user-select: none; 
}

.devcfg .modes .svgicon .fill {
    fill: var(--black-35);
}

.devcfg .modes .mode {
    color: var(--black-80);
    font-size: 14px;
    padding-left: 5px;
}

.devcfg .modes .down {
    font-size: 24px;
    position: relative;
    height: 20px;
    overflow: hidden;

    display: flex;
    align-items: center;
    text-align: center;
    justify-content:center;
}

.devcfg .modules .subpanel .header,.subheader {
    font-size: 14px;
    color: var(--black-45);
}

.devcfg .modules .subpanel .subheader {
    padding-top: 4px;
    font-size: 14px;
    padding-bottom: 4px;
}

.devcfg .modal .dialog .newnode .prompt {
    font-size: 15px;
}

.devcfg .modal .editbox {
    padding: 5px;
}

.devcfg .modal .newnode .svgicon {
    padding-top: 3px;
}

.devcfg .modal .newnode .modes {
    padding-top: 8px;
    padding-left: 10px;
    padding-bottom: 8px;
}

.devcfg .modal .dialog .field .editable {
    padding: 0px;
    padding-left: 5px;
    padding-right: 5px;
    /* --black-10 (#282f36) vanishes against --ui-modal-bg (#293037): the
       input read as background-less until focus drew its border */
    background-color: var(--black-05);
}

/* Edit state: the darker fill covers the WHOLE input box — the generic
   \`.modal .dialog .edit\` rule painted only the inner contenteditable,
   leaving a lighter frame around it (Jared: "doesn't fill full box") */
.devcfg .modal .dialog .field .editable.edit {
    background-color: var(--black-02);
}

.devcfg .modal .dialog .field .editable > .edit {
    background-color: transparent;
    border-radius: 0;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

/* Selecting text lifts it to near-white over a visible highlight */
.devcfg .modal .dialog .field .editable ::selection,
.devcfg .modal .dialog .field .editable::selection {
    background-color: var(--black-25);
    color: var(--black-90);
}

/* Modal fields run full width, unlike the 260px config-panel naming row */
.devcfg .modal .dialog .field.name .naming .name {
    width: 100%;
}

/* The long-name fade must end on the modal input bg (--black-05), not the
   config panel's --black-10 — mismatched, it reads as a gradient smear */
.devcfg .modal .dialog .field.name .naming .name::after {
    background: linear-gradient(to right, transparent, var(--black-05));
}
`, "",{"version":3,"sources":["webpack://./src/device.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sEAAsE;IACtE,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;;IAEZ,eAAe;IACf,sBAAsB;IACtB,iBAAiB;;IAEjB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mEAAmE;IACnE,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;;IAEjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;;IAEb,eAAe;;IAEf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;+EAC+E;AAC/E;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;;IAEhB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;;IAEjC,eAAe;;IAEf,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;gDACgD;AAChD;IACI,iCAAiC;IACjC,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB;+CAC2C;IAC3C,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;;IAElB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;;IAEjB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;kDAGkD;AAClD;;IAEI,iFAAiF;AACrF;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;mEACmE;AACnE;IACI,uEAAuE;AAC3E;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;iDACiD;AACjD;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;;IAElB,sBAAsB;IACtB,gBAAgB;;IAEhB,YAAY;;IAEZ,eAAe;IACf,kBAAkB;IAClB,6BAA6B;;IAE7B,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;;IAEjC,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;;IAEtB,aAAa;IACb,oBAAoB;;IAEpB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;kEAC8D;IAC9D,iCAAiC;AACrC;;AAEA;;uEAEuE;AACvE;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;;IAEI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA,0EAA0E;AAC1E;IACI,WAAW;AACf;;AAEA;yEACyE;AACzE;IACI,mEAAmE;AACvE","sourcesContent":[".devcfg {\n    height: 100%;\n    width: 100%;\n}\n\n.devcfg:not(.empty) {\n    /* The workspace is the black gutter between the two panel surfaces. */\n    background-color: var(--panel-bg-level-0);\n    padding-left: 20px;\n    padding-right: 20px;\n    overflow-x: auto;\n    overflow-y: auto;\n}\n\n.devcfg.empty {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.devcfg.empty .empty {\n    padding: 50px;\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.devcfg > .header {\n    position: relative;\n    display: flex;\n    text-align: left;\n    align-items: center;\n}\n\n.devcfg > .header > .title {\n    padding: 15px;\n    padding-left: 8px;\n    width: 300px;\n\n    font-size: 18px;\n    color: var(--black-80);\n    font-weight: bold;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 70%, transparent 100%);\n}\n\n.devcfg > .header > .popup-trigger {\n    position: absolute;\n    font-size: 24px;\n    left: 300px;\n}\n\n.devcfg .dev-panel {\n    background-color: var(--black-02);\n    border-radius: 6px;\n    height: 100%;\n    width: 400px;\n    padding: 20px;\n}\n\n.devcfg .field {\n    margin-top: 4px;\n    margin-bottom: 4px;\n}\n\n.devcfg .field:nth-child(1) {\n    margin-top: 0px;\n}\n\n.devcfg .field:nth-last-child() {\n    margin-bottom: 0px;\n}\n\n.devcfg .field > .name {\n    color: var(--black-65);\n    font-size: 15px;\n    padding: 6px;\n}\n\n.devcfg .field.name .naming {\n    display: flex;\n    justify-content: left;\n    position: relative;\n}\n\n.devcfg .field.name .naming .name {\n    position: relative;\n    width: 260px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.devcfg .field.name .naming .name::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 30%;\n    height: 100%;\n    content: '';\n    background: linear-gradient(to right, transparent, var(--black-10));\n    pointer-events: none;\n}\n\n.devcfg .field.name .naming .name.edit {\n    mask: none;\n}\n\n.devcfg .field.name .naming .name.edit::after {\n    background: none;\n}\n\n.devcfg .field .notes {\n    padding-right: 5px;\n    padding-bottom: 3px;\n    color: var(--black-65);\n}\n\n.devcfg .field .editable.notes,\n.devcfg .field .editable.notes.edit {\n    white-space: pre-wrap;\n    overflow-y: auto;\n    min-height: 100px;\n    max-height: 380px;\n}\n\n.devcfg .field.name .naming > .reset {\n    width: 24px;\n    padding-left: 5px;\n\n    text-align: center;\n    align-items: center;\n    display: flex;\n\n    font-size: 24px;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.devcfg .field.name .naming > .reset.disabled {\n    color: var(--black-35);\n}\n\n/* A bare glyph, so it lifts relative to its own colour instead of taking a\n   surface veil. It keeps its pointer cursor when disabled, hence the :not(). */\n.devcfg .field.name .naming > .reset:not(.disabled):hover {\n    filter: brightness(var(--hover-lift));\n}\n\n.devcfg .field .editable {\n    min-height: 28px;\n\n    border-radius: 6px;\n    padding: 6px;\n    padding-right: 0px;\n    border: 1px solid var(--black-02);\n\n    font-size: 13px;\n\n    background-color: var(--black-10);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.devcfg .field .editable.edit {\n    border-color: var(--black-35);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: clip;\n}\n\n.devcfg .field .editable :is(.edit, .view) {\n    min-width: 10px;\n}\n\n.devcfg .panels {\n    display: flex;\n    gap: 20px;\n    height: 100%;\n}\n\n.devcfg .panels > .device {\n    background-color: var(--black-05);\n    width: 316px;\n    padding-right: 20px;\n    border-radius: 8px;\n    padding: 12px;\n    flex-shrink: 0;\n}\n\n/* Config owns its existing content inset; the parent owns the separate black\n   20px gutter between the two panel surfaces. */\n.devcfg .panels > .modules {\n    background-color: var(--black-02);\n    flex-grow: 1;\n    flex-shrink: 0;\n    padding-left: 20px;\n    /* Matches the config panel's inset so the sort control starts on the same\n       line as its first field (Gosta, Aug 4) */\n    padding-top: 12px;\n    padding-bottom: 60px;\n    max-width: 1000px;\n    min-width: 800px;\n}\n\n.devcfg .panels > .modules > .node-sort {\n    width: 75px;\n    height: 22px;\n    border-radius: 4px;\n\n    font-size: 13px;\n    font-weight: bold;\n\n    padding-left: 12px;\n    padding-right: 10px;\n    margin-bottom: 8px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none;\n\n    color: var(--black-05);\n    background-color: var(--black-80);\n}\n\n.devcfg .panels > .modules > .node-sort:hover {\n    background-color: var(--black-65);\n}\n\n.devcfg .panels > .modules > .module {\n    background-color: var(--black-05);\n    padding: 20px;\n    padding-top: 10px;\n    border-radius: 6px;\n    margin-bottom: 6px;\n}\n\n/* Node cards are reordered by dragging, so they react to the pointer. The\n   port-assign subpanel keeps its own darker fill: the card lifts, the box the\n   node sits in doesn't. Menus portal out of the card and can cover their own\n   trigger, so hold the hover while one is open. */\n.devcfg .panels > .modules > .module:hover,\n.devcfg .panels > .modules > .module:has([data-menu-open]) {\n    background-image: linear-gradient(var(--hover-veil-soft), var(--hover-veil-soft));\n}\n\n.devcfg .panels > .modules > .module.selected {\n    border-color: var(--black-45);\n}\n\n.devcfg .node-new {\n    width: fit-content;\n    background-color: green;\n    margin-top: 20px;\n}\n\n.devcfg .node-new .add {\n    font-size: 18px;\n}\n\n.devcfg .modules .port-assign .shape {\n    text-align: left;\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n    flex-direction: column;\n}\n\n.devcfg .panels > .modules .shape .ports {\n    height: 24px;\n    width: 220px;\n    text-align: center;\n    display: flex;\n    justify-content:center;\n    align-items: center;\n}\n\n.devcfg .panels > .modules .shape .ports .port-choice {\n    text-align: center;\n    display: flex;\n    justify-content:center;\n    align-items: center;\n    width: 50%;\n    flex-direction: column;\n}\n\n.portlabel .disabled {\n    color: var(--black-45);\n}\n\n.port-choose {\n    background-color: red;\n}\n\n.portlabel {\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.portlabel .port {\n    color: var(--black-80);\n}\n\n.portlabel .mod {\n    padding-left: 5px;\n    color: var(--black-45);\n}\n\n.portlabel .submenu-list {\n    transform: translate(30px, -3px);\n}\n\n.devcfg .panels .modules .shape .ports.high {\n    position: relative;\n}\n\n.devcfg .panels .modules .shape .ports.low {\n    position: relative;\n}\n\n.devcfg .panels .modules .shape .ports .port-choice .port {\n    background-color: var(--black-00);\n    border: 1px solid var(--black-35);\n    color: var(--black-65);\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 4px;\n    padding: 1px 4px 1px 4px;\n    min-width: 60px;\n}\n\n.devcfg .panels .modules .shape .ports.low .port-choice .port {\n    background-color: var(--black-45);\n    color: var(--black-00);\n}\n\n/* Clicking a port chip opens its assignment menu. The low chips are already\n   light, so the veil reads weakest there of anywhere in the app. */\n.devcfg .panels .modules .shape .ports .port-choice .port:hover {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n.devcfg .panels .modules .shape .ports .arrow {\n    font-size: 30px;\n    height: 22px;\n\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content:center;\n}\n\n.devcfg .panels .modules .shape .ports .arrow.to {\n    position: relative;\n    top: -3px;\n}\n\n.devcfg .panels .modules .shape .ports .arrow.from {\n    position: relative;\n    bottom: -4px;\n}\n\n.devcfg .modules .shape .chain-module .channel  {\n    right: 8px;\n}\n\n.devcfg .modules .shape .chain-module .channel.L  {\n    right: 36px;\n}\n\n.devcfg .panels .modules .grab {\n    position: relative;\n    top: -3px;\n    right: -2px;\n}\n\n.devcfg .dir {\n    background-color: red;\n}\n\n.devcfg .panels .modules .body {\n    display: flex;\n    justify-content:left;\n    width: 100%;\n    position: relative;\n    padding-top: 10px;\n}\n\n.devcfg .modules .body .header {\n    font-weight: 600;\n    padding-bottom: 10px;\n}\n\n.devcfg .modules .status {\n    width: 255px;\n}\n\n.devcfg .modules .status .completion {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    font-size: 13px;\n    color: var(--green-1);\n}\n\n.devcfg .modules .status .completion.incomplete {\n    color: var(--red-3);\n}\n\n/* The info mark is a real element, not a ::after, so the tooltip has something\n   to hover on that isn't the whole status line */\n.devcfg .modules .status .completion .info {\n    font-size: 17px;\n    font-weight: bold;\n    cursor: default;\n}\n\n.devcfg .modules .subpanel .port-status {\n    margin-top: 16px;\n}\n\n.devcfg .modules .module .header {\n    width: 310px;\n    display: flex;\n    align-items: center;\n    text-align: left;\n    justify-content: space-between;\n}\n\n.devcfg .modules .module .header .name {\n    background-color: var(--black-10);\n}\n\n.devcfg .module .header .editable .name {\n    position: relative;\n    padding: 5px;\n    padding-left: 8px;\n    padding-right: 8px;\n\n    color: var(--black-80);\n    font-weight: 500;\n\n    width: 280px;\n\n    font-size: 14px;\n    border-radius: 3px;\n    border: 1px solid transparent;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.devcfg .module .header .editable .edit.name {\n    border: 1px solid var(--black-35);\n    mask: none;\n}\n\n.devcfg .modules .module .header .popup-trigger {\n    font-size: 22px;\n}\n\n.devcfg .modules .subpanel.port-assign {\n    background-color: var(--black-02);\n\n    height: 134px;\n\n    display: flex;\n    align-items: center;\n    text-align: center;\n}\n\n.devcfg .modules .subpanel {\n    padding: 10px;\n}\n\n.devcfg .modes {\n    color: var(--black-65);\n\n    display: flex;\n    justify-content:left;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.devcfg .modes .svgicon .fill {\n    fill: var(--black-35);\n}\n\n.devcfg .modes .mode {\n    color: var(--black-80);\n    font-size: 14px;\n    padding-left: 5px;\n}\n\n.devcfg .modes .down {\n    font-size: 24px;\n    position: relative;\n    height: 20px;\n    overflow: hidden;\n\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content:center;\n}\n\n.devcfg .modules .subpanel .header,.subheader {\n    font-size: 14px;\n    color: var(--black-45);\n}\n\n.devcfg .modules .subpanel .subheader {\n    padding-top: 4px;\n    font-size: 14px;\n    padding-bottom: 4px;\n}\n\n.devcfg .modal .dialog .newnode .prompt {\n    font-size: 15px;\n}\n\n.devcfg .modal .editbox {\n    padding: 5px;\n}\n\n.devcfg .modal .newnode .svgicon {\n    padding-top: 3px;\n}\n\n.devcfg .modal .newnode .modes {\n    padding-top: 8px;\n    padding-left: 10px;\n    padding-bottom: 8px;\n}\n\n.devcfg .modal .dialog .field .editable {\n    padding: 0px;\n    padding-left: 5px;\n    padding-right: 5px;\n    /* --black-10 (#282f36) vanishes against --ui-modal-bg (#293037): the\n       input read as background-less until focus drew its border */\n    background-color: var(--black-05);\n}\n\n/* Edit state: the darker fill covers the WHOLE input box — the generic\n   `.modal .dialog .edit` rule painted only the inner contenteditable,\n   leaving a lighter frame around it (Jared: \"doesn't fill full box\") */\n.devcfg .modal .dialog .field .editable.edit {\n    background-color: var(--black-02);\n}\n\n.devcfg .modal .dialog .field .editable > .edit {\n    background-color: transparent;\n    border-radius: 0;\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n/* Selecting text lifts it to near-white over a visible highlight */\n.devcfg .modal .dialog .field .editable ::selection,\n.devcfg .modal .dialog .field .editable::selection {\n    background-color: var(--black-25);\n    color: var(--black-90);\n}\n\n/* Modal fields run full width, unlike the 260px config-panel naming row */\n.devcfg .modal .dialog .field.name .naming .name {\n    width: 100%;\n}\n\n/* The long-name fade must end on the modal input bg (--black-05), not the\n   config panel's --black-10 — mismatched, it reads as a gradient smear */\n.devcfg .modal .dialog .field.name .naming .name::after {\n    background: linear-gradient(to right, transparent, var(--black-05));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
